import React from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {AdminFrame} from "./components/admin-frame/AdminFrame";
import {AdminFrameRoot} from "./components/admin-frame/AdminFrameRoot";
import {Login} from "./components/login/Login";
import {UsersListPage} from "./components/users/UsersListPage";
import {InvoicesListPage} from "./components/invoices/InvoicesListPage";
import {FpServicesManagementPage} from "./components/fp-services/FpServicesManagementPage";
import {InvoicePaymentSettingsPage} from "./components/invoice-payment-settings/InvoicePaymentSettingsPage";
import {SubscriptionsListPage, SubscriptionsListPageProps} from "./components/subscriptions/SubscriptionsListPage";
import {SubscriptionInvoicesListPage} from "./components/subscriptions/SubscriptionInvoicesListPage";

type UserConfirmationCallback = (allowTransition: boolean) => void;
export type UserConfirmationFunction = (message: string, callback: UserConfirmationCallback) => void;

// placeholder BrowserRouter confirmation function to be overwritten by AdminFrame
let getUserConfirmationFunction: UserConfirmationFunction = function (message, callback) {
    const allowTransition = window.confirm(message);
    callback(allowTransition);
};

// get the currently defined user confirmation function
let getUserConfirmationFunctionWrapper: UserConfirmationFunction =
    (message, callback) => getUserConfirmationFunction(message, callback);

export default (
    <BrowserRouter getUserConfirmation={getUserConfirmationFunctionWrapper}>
        <Switch>
            <Route exact path="/login" component={Login}/>

            <AdminFrame
                setUserConfirmationFunction={
                    function (functionToUse: UserConfirmationFunction) {
                        getUserConfirmationFunction = functionToUse
                    }
                }
            >
                <Route exact path="/" component={AdminFrameRoot}/>
                <Switch>
                    <Route exact path="/users" component={UsersListPage}/>
                    <Route
                        exact
                        path="/users/add"
                        render={
                            function (props) {
                                return (
                                    <UsersListPage
                                        {...props}
                                        showCreateModal={true}
                                    />
                                );
                            }
                        }
                    />
                    <Route exact path="/users/:userId" component={UsersListPage}/>

                    <Route exact path="/invoices" component={InvoicesListPage}/>
                    <Route exact path="/invoices/:invoiceId" component={InvoicesListPage}/>
                    <Route exact path="/invoices/fp-invoice/:fpInvoiceId" component={InvoicesListPage}/>
                    <Route
                        exact
                        path="/invoices/make-subscription-from-fp-invoice/:fpInvoiceIdForSubscription"
                        component={InvoicesListPage}
                    />

                    <Route exact path="/subscriptions" component={SubscriptionsListPage}/>
                    <Route exact path="/subscriptions/invoices/:invoiceId" component={SubscriptionsListPage}/>
                    <Route
                        exact
                        path="/subscriptions/add"
                        render={
                            function (props) {
                                return (
                                    <SubscriptionsListPage
                                        {...props as SubscriptionsListPageProps}
                                        showCreateSubscriptionModal={true}
                                    />
                                );
                            }
                        }
                    />
                    <Route exact path="/subscriptions/:subscriptionId" component={SubscriptionsListPage}/>

                    <Route exact path="/subscription-invoices" component={SubscriptionInvoicesListPage}/>
                    <Route
                        exact
                        path="/subscription-invoices/subscriptions/:subscriptionId"
                        component={SubscriptionInvoicesListPage}
                    />
                    <Route exact path="/subscription-invoices/:invoiceId" component={SubscriptionInvoicesListPage}/>

                    <Route exact path="/fp-qbo-integration" component={FpServicesManagementPage}/>
                    <Route
                        exact
                        path="/fp-qbo-integration/for-service-type/:fpServiceTypeId"
                        component={FpServicesManagementPage}
                    />

                    <Route exact path="/invoice-payment-settings" component={InvoicePaymentSettingsPage}/>
                </Switch>
            </AdminFrame>
        </Switch>
    </BrowserRouter>
);
